import { LoadableAfterPaint } from '@confluence/loadable';

export const HomepageIcon = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HomepageIcon" */ './HomepageIcon.tsx')).HomepageIcon,
});
